import { AbstractCreativeModel } from './Creative'
export class InfeedModel extends AbstractCreativeModel {
  constructor(data = {}) {
    super()
    const {
      id,
      anCreativeId,
      creativeFolderId,
      name,
      title,
      description,
      landingPageUrl,
      status,
      anAuditStatus,
      anAuditFeedback,
      anGoogleStatus,
      anGoogleFeedback,
      smartNewsAuditStatus,
      callToAction,
      sponsoredBy,
      mainImageId,
      iconImageId,
    } = data
    this.id = id
    this.anCreativeId = anCreativeId
    this.creativeFolderId = creativeFolderId
    this.name = name
    this.title = title
    this.description = description
    this.landingPageUrl = landingPageUrl
    this.status = status
    this.anAuditStatus = anAuditStatus
    this.anAuditFeedback = anAuditFeedback
    this.anGoogleStatus = anGoogleStatus
    this.anGoogleFeedback = anGoogleFeedback
    this.smartNewsAuditStatus = smartNewsAuditStatus
    this.callToAction = callToAction
    this.sponsoredBy = sponsoredBy
    this.mainImageId = mainImageId
    this.iconImageId = iconImageId
  }

  static assign(data) {
    return new InfeedModel(data)
  }
}
